import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './ParentalRegister.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses, } from '@mui/material/LinearProgress';
import URL from "../../../../constants/url";
import { useNavigate, useLocation } from "react-router-dom";
import Modal from '../../../../components/comm/Modal';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import {
    getCommCdList
} from '../../../../assets/js/comm';


//상위 스텝 바 
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}));

const ParentalRegister = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { hsptlNm = '', hsptlCd = '' } = location.state || {};
    const [step, setStep] = useState(1);
    const [inputText, setInputText] = useState("");
    const [famlyList, setFamlyList] = useState([]);
    const [selectedRelation, setSelectedRelation] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [preOpen, setPreOpen] = useState(false);      // 1차 모달창
    const [finishOpen, setFinishOpen] = useState(false);    // 2차 모달창


    const [backConfirmOpen, setBackConfirmOpen] = useState(false);  // 뒤로가기 확인 창
    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    //뒤로가기 
    const handleBackClick = () => {
        setBackConfirmOpen(true);
    };

    const handleConfirmBack = () => {
        setBackConfirmOpen(false);
        navigate(URL.HOSPITAL_PARENTALSETTINGS, {
            state: {
                hsptlCd: hsptlCd
            },
            replace: true
        });
    };

    /**
     * 가족 코드 조회
     */
    const getFamlyCodeList = () => {

        getCommCdList("FAMLY_TY_CD")
            .then( (res) => {
                if(res.length > 0) {
                    setFamlyList(res);
                } else {
                    setFamlyList([]);
                }
            })
            .catch( (err) => {
               console.log(" =======> getFamlyList Error : ", err );
            });
    };

    useEffect(() => {
        getFamlyCodeList();
    }, []);

    
    // 지인 및 가족 연락처 저장

    const saveFamly = useCallback(async () => {

        
        console.log("inputText : ", inputText);
        console.log("selectedRelation : ", selectedRelation);
        console.log("phoneNumber : ", phoneNumber);

        const url = "/hsptl/saveHsptlFamlyInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            usrInfoId : user.usrInfoId,
            famlyTyCd : selectedRelation,
            famlyNm : inputText,
            famlyMblNo : phoneNumber
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setFinishOpen(false);
                navigate(URL.HOSPITAL_PARENTALSETTINGS, {
                    replace: true,
                    state: { hsptlCd: hsptlCd }
                });
            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })


    }, [inputText, selectedRelation, phoneNumber]);


    const handleNext = () => {
        if (step === 1 && inputText.trim().length >= 1) {
            setStep(2);
        } else if (step === 2 && selectedRelation !== "") {
            setStep(3);
        } else if (step === 3) {
            const phoneRegex = /^01[016789][0-9]{7,8}$/;
            if (!phoneRegex.test(phoneNumber)) {
                setPreOpen(true);
                return;
            }

            setFinishOpen(true);
        }
    };

    const activeEnter = (e) => {
        if (e.key === "Enter" && inputText.trim()) {
            handleNext();
        }
    }

    const preModal = () => {
        setPreOpen(true);
    }

    const nextModal = () => {
        setPreOpen(false);
        setFinishOpen(true)
    }

    const cancelModal = () => {
        setFinishOpen(false)
    }

    return (
        <>
            <HeadSub title="가족・보호자 등록" onBack={handleBackClick} />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style["progress-box"]}>
                        <p className={style["progress-count"]}>
                            <span>{step}</span>/<span>3</span>
                        </p>

                        <BorderLinearProgress
                            variant="determinate"
                            value={(step / 3) * 100}
                            className={style['border-linear-progress']}
                        />
                    </div>

                    {step === 1 && <strong className={style["text-title"]}> 가족·보호자의 이름을 입력해주세요. </strong>}
                    {step === 2 && <strong className={style["text-title"]}> {inputText}님과 어떤 관계이신가요? </strong>}
                    {step === 3 && <strong className={style["text-title"]}> {inputText}님의 휴대전화번호를 입력해주세요. </strong>}




                    {/* 이름 입력 */}
                    {step === 1 && (
                        <div className={style['content-box']}>
                            <div className='input-box' data-type='b'>
                                <input
                                    type="text"
                                    id="family-name"
                                    placeholder='이름'
                                    value={inputText}
                                    onChange={(e) => setInputText(e.target.value)}
                                    onKeyDown={activeEnter} />
                            </div>
                        </div>
                    )}

                    {/* 관계 선택 */}
                    {step === 2 && (
                        <div className={style['content-box']}>
                            <div className={style['select-list-box']}>
                                <ul>
                                    {famlyList.map((item, idx) => (
                                        <li key={item.cdId}>
                                            <div className='radio-selectbox'>
                                                <input
                                                    type="radio"
                                                    id={`parental${idx + 1}`}
                                                    name='parental-select'
                                                    value={item.cdId}
                                                    checked={selectedRelation === item.cdId}
                                                    onChange={(e) => setSelectedRelation(e.target.value)}
                                                />
                                                <label htmlFor={`parental${idx + 1}`}>
                                                    <span>{item.cdNm}</span>
                                                </label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}


                    {/* 휴대폰 번호 입력 */}
                    {step === 3 && (
                        <div className={style['content-box']}>
                            <div className='input-box' data-type='b'>
                                <input
                                    type="number"
                                    id="phonNumber"
                                    placeholder='-없이 숫자만 입력'
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                        </div>
                    )}


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">

                            {step === 1 ? (
                                <div className='btn-layout' data-btn-num="1">
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        disabled={inputText.trim().length === 0}
                                        onClick={handleNext}
                                    >
                                        <span>다음</span>
                                    </button>
                                </div>
                            ) : step === 2 ? (
                                <div className='btn-layout' data-btn-num="1">
                                    <button
                                        className="btn"
                                        data-btn-type="fill-main"
                                        data-btn-size="lg"
                                        disabled={selectedRelation === ""}
                                        onClick={handleNext}
                                    >
                                        <span>다음</span>
                                    </button>
                                </div>
                            ) :
                                <div className='btn-layout' data-btn-num="1">
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleNext}>
                                        <span>등록 완료</span>
                                    </button>
                                </div>
                            }

                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}
                </div>
            </div>


            <Modal isOpen={preOpen} setIsOpen={setPreOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 올바른 휴대전화번호를 입력해주세요.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout' data-type='b'>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" data-btn-width='100' onClick={() => setPreOpen(false)}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal isOpen={finishOpen} setIsOpen={setFinishOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 등록 완료하시겠어요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelModal}>
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={saveFamly


                                    // ()=> navigate(URL.HOSPITAL_PARENTALSETTINGS, {
                                    //     state: {
                                    //         name: inputText,
                                    //         relation: selectedRelation,
                                    //         phone: phoneNumber,
                                    //         fromRegister: true,
                                    //         hosptNm: hosptNm,
                                    //     },
                                    //     replace: true,

                                    // })


                                }
                            >
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal isOpen={backConfirmOpen} setIsOpen={setBackConfirmOpen}>
                <div className="modal-box" data-type="a">
                    <div className="modal-top-box">
                        <div className="title-box">
                            <p>작성을 그만하시겠어요?</p>
                        </div>
                        <div className="sub-box">
                            <span> 작성 중이던 내용은 모두 사라집니다.</span>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className="btn-layout">
                            <button
                                className="btn"
                                data-btn-type="fill-gray"
                                data-btn-size="md"
                                onClick={() => setBackConfirmOpen(false)}
                            >
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={handleConfirmBack}
                            >
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ParentalRegister;
